import { FC } from 'react';
import styled from 'styled-components';

export interface IProps {
  /** Text color. Defaults to theme.vars.newColor.darkGS1 */
  color?: string;
  /** Font size. Optional */
  fontSize?: string;
  fontWeight?: string;
  bold?: boolean;
}
const SpanElement = styled.span<IProps>`
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '14px')};
  line-height: ${({ fontSize }) => (fontSize ? '1.5' : '24px')};
  font-weight: ${({ fontWeight, bold }) => (fontWeight ? fontWeight : bold ? '600' : '350')};
  color: ${props => (props.color ? props.color : props.theme.vars.newColor.darkGS1)};
  margin: 0;
  padding: 0;
`;

export const Span: FC<IProps> = props => {
  const { color, fontWeight } = props;
  return (
    <SpanElement color={color} fontWeight={fontWeight} fontSize={props.fontSize} bold={props.bold} data-testid="Span">
      {props.children}
    </SpanElement>
  );
};
